import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=28f25374&scoped=true"
import script from "./BackBtn.vue?vue&type=script&lang=js"
export * from "./BackBtn.vue?vue&type=script&lang=js"
import style0 from "./BackBtn.vue?vue&type=style&index=0&id=28f25374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f25374",
  null
  
)

export default component.exports